











import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
name: 'sign-header',
  components: {

  },
  props: {
    state: String
  },
  data() {
    return {
      s: style
    }
  },
  computed: {
    isLogin(): boolean {
      return this.state == 'login';
    },
    isReg(): boolean {
      return this.state == 'reg';
    }
  }
})
